import { Card, CardBody, CardHeader, Divider, Button, Chip } from "@nextui-org/react";
import { EyeIcon } from "@heroicons/react/24/outline";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import ClientDataGrid from "../../../../components/elements/ClientDataGrid";
import { getFetcher } from "../../../../services/api";
import useSWR from "swr";
import useAuth from "../../../../hooks/useAuth";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import { useMemo } from "react";
import { formattedDate } from "../../../../services/helpers";
import StatusRekomendasi from "../../../../enums/statusRekomendasi";

export default function IndexPage() {
  const { user } = useAuth();
  const { getRecomendationDetailPath } = useCustomNavigate();

  const apiUrl = user?.id ? `/api/rekom/permohonan/search?delegasiUserId=${user.id}&returnAll=true&sortBy=tanggalPengajuan&sortOrder=desc` : null;
  const { data, isLoading } = useSWR(apiUrl, getFetcher);

  const columns = useMemo(
    () => [
      { field: "tanggalPengajuan", headerName: "Tanggal Pengajuan", valueGetter: (value, row) => formattedDate(row.tanggalPengajuan) },
      { field: "kodePermohonan", headerName: "Kode Registrasi" },
      { field: "company", headerName: "Perusahaan", valueGetter: (value, row) => row?.company?.name },
      { field: "jenisPermohonan", headerName: "Jenis Permohonan" },
      {
        field: "status",
        headerName: "Status",
        renderCell: (params) => (
          <Chip size="sm" color={params?.row?.status === StatusRekomendasi.MENUNGGU_DI_PROSES ? "warning" : "primary"} variant="flat">
            {params?.row?.status}
          </Chip>
        ),
      },
      {
        field: "action",
        headerName: "Aksi",
        renderCell: (params) => (
          <div className="flex gap-2">
            <Button size="sm" color="primary" isIconOnly onClick={() => getRecomendationDetailPath(params?.row?.id)}>
              <EyeIcon className="size-4" />
            </Button>
          </div>
        ),
        sortable: false,
        filterable: false,
      },
    ],
    [getRecomendationDetailPath]
  );

  return (
    <RootAdmin>
      <Card className="w-full mt-3" radius="sm">
        <CardHeader>
          <p className="text-md">Tugas Saya - Rekomendasi Pengangkutan B3</p>
        </CardHeader>
        <Divider />
        <CardBody className="w-full h-[550px] p-5">
          <ClientDataGrid columns={columns} rows={data?.applications} isLoading={isLoading} />
        </CardBody>
      </Card>
    </RootAdmin>
  );
}
